import { REQUEST_USER_QUERY_SUCCESS, REQUEST_USER_QUERY_FAILURE } from '../constants/actionTypes';

const INITIAL_STATE = { datas: [], errors: null };

export default function usersQueryData(state=INITIAL_STATE, action) {

  switch(action.type) {
    case REQUEST_USER_QUERY_SUCCESS:
      return { ...state, datas: action.payload.data, errors: null }
    case REQUEST_USER_QUERY_FAILURE:
      return { ...state, ids: [], errors: action.payload.response && action.payload.response.data.errors }
    default:
      return state;
  }
}
